import React from "react";

import topnotch_6 from "./images/topnotch/topnotch_6";
import topnotch_2 from "./images/topnotch/topnotch_2";
import img_new_1 from './images/topnotch/img_new_1'
import {Link} from 'react-router-dom'

export default function Choose() {
  return (
    <>
      {/* <div class="page-wrapper sec-mar">
        <article
          id="post-15"
          class="post-15 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="15"
              class="elementor elementor-15"
            >
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-7570cb6 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="7570cb6"
                data-element_type="section"
              >
                <div class="elementor-container elementor-column-gap-no">
                  <div
                    class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0751275"
                    data-id="0751275"
                    data-element_type="column"
                  >
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-96da640 elementor-widget elementor-widget-spinner_slider"
                        data-id="96da640"
                        data-element_type="widget"
                        data-widget_type="spinner_slider.default"
                      >
                        <div class="elementor-widget-container">
                          <script></script>

                          <div class="banner-section2">
                            <div class="banner2-spring1"></div>
                            <div class="banner2-spring2"></div>
                            <div class="banner2-circle1"></div>
                            <div class="banner2-circle2"></div>
                            <img
                              decoding="async"
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-vector.png"
                              class="banner2-vector"
                              alt="image"
                            />

                           
                            <div class="swiper banner2">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    src={topnotch_6}
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  <div class="container">
                                    <div class="row d-flex justify-content-center align-items-center">
                                      <div class="col-xl-7 col-lg-10">
                                        <div class="banner2-content">
                                          <span>
                                            WE ARE TOP NOTCH MEDIA WORKS
                                          </span>
                                          <h2>Why Choose US</h2>

                                         
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  
                                </div>
                              </div>
                            </div>
                            <div class="banner2-pagination d-flex justify-content-center flex-row align-items-center gap-2"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div> */}
      {/* main section */}
      {/* <section
        class="elementor-section elementor-top-section elementor-element elementor-element-96b7957 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="96b7957"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f0e1c61"
            data-id="f0e1c61"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-f5286b2 elementor-widget elementor-widget-spinner_heading"
                data-id="f5286b2"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title2 primary4">
                    <span>- This Is Why
-</span>
                    <div>
                      <h3 className="text-white"> We Should Work Together
</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-55871ee elementor-widget elementor-widget-spinner_job"
                data-id="55871ee"
                data-element_type="widget"
                data-widget_type="spinner_job.default"
              >
                <div class="elementor-widget-container">
                  <div class="job-section">
                    <div class="container">
                      <div class="row justify-content-center g-4">
                        <div class="col-lg-4 col-md-6 col-sm-10">
                          <div
                            class="jobpost-item hover-border2 wow fadeInDown"
                            data-wow-duration="1.5s"
                            data-wow-delay="0.2s"
                          >
                            <div class="job-header">
                              <div class="icon">
                                <img
                                  width="60"
                                  height="60"
                                  src="https://cdn.pixabay.com/photo/2016/08/19/20/37/time-1606153__340.png"
                                  class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  loading="lazy"
                                />
                              </div>
                              <h4 class="title">
                                <a href="#">Always On Time</a>
                              </h4>
                            </div>
                            <div class="job-body">
                              <p>
                                It’s really clear that the most precious
                                resource we all have is time
                                <br />
                                <br />
                                <br />
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-10">
                          <div
                            class="jobpost-item hover-border2 wow fadeInDown"
                            data-wow-duration="1.5s"
                            data-wow-delay="0.2s"
                          >
                            <div class="job-header">
                              <div class="icon">
                                <img
                                  width="60"
                                  height="60"
                                  src="https://media.istockphoto.com/id/1204658131/vector/green-tick-and-confirm-icon-vector-design.jpg?s=612x612&w=0&k=20&c=cKKIo_Syz6b-_F-ovTLIFbzBbp6jB5l0dLXqBQDWTfs="
                                  class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  loading="lazy"
                                />
                              </div>
                              <h4 class="title">
                                <a href="#">Hard Working</a>
                              </h4>
                            </div>
                            <div class="job-body">
                              <p>
                                Working in teams increases collaboration. And
                                the sharing of ideas and can go a long way in
                                giving teams a productivity boost.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-10">
                          <div
                            class="jobpost-item hover-border2 wow fadeInDown"
                            data-wow-duration="1.5s"
                            data-wow-delay="0.2s"
                          >
                            <div class="job-header">
                              <div class="icon">
                                <img
                                  width="60"
                                  height="60"
                                  src="https://media.istockphoto.com/id/1172413128/vector/december-23-daily-calendar-icon-in-flat-design-style.jpg?s=612x612&w=0&k=20&c=mjaVWabRW7bQ0dy1CbVRkFc5L5-x7FnHY_105MtduJE="
                                  class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  loading="lazy"
                                />
                              </div>
                              <h4 class="title">
                                <a href="#">24/7 Branding</a>
                              </h4>
                            </div>
                            <div class="job-body">
                              <p>
                                We believe in excellent work, make your name A
                                Brand with our passionate and hard-working team.
                                <br />
                                <br />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section
        class="elementor-section elementor-top-section elementor-element elementor-element-96b7957 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="96b7957"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f0e1c61"
            data-id="f0e1c61"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-f5286b2 elementor-widget elementor-widget-spinner_heading"
                data-id="f5286b2"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
               
              </div>
              <div
                class="elementor-element elementor-element-55871ee elementor-widget elementor-widget-spinner_job"
                data-id="55871ee"
                data-element_type="widget"
                data-widget_type="spinner_job.default"
              >
                <div class="elementor-widget-container">
                  <div class="job-section">
                    <div class="container">
                      <div class="row justify-content-center g-4">
                        <div class="col-lg-4 col-md-6 col-sm-10">
                          <div
                            class="jobpost-item hover-border2 wow fadeInDown"
                            data-wow-duration="1.5s"
                            data-wow-delay="0.2s"
                          >
                            <div class="job-header">
                              <div class="icon">
                                <img
                                  width="60"
                                  height="60"
                                  src="https://media.istockphoto.com/id/1281579246/vector/back-money-refund-icon-orange-version.jpg?s=612x612&w=0&k=20&c=-I-f-zbqlWxNAJWuN4tGUIPxKckyRFKNFaABpZIByxY="
                                  class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  loading="lazy"
                                />
                              </div>
                              <h4 class="title">
                                <a href="#">Maximum Profitability
</a>
                              </h4>
                            </div>
                            <div class="job-body">
                              <p>
                              You have to work on the business first before it works for you.


                                <br />
                                <br />
                                <br />
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-10">
                          <div
                            class="jobpost-item hover-border2 wow fadeInDown"
                            data-wow-duration="1.5s"
                            data-wow-delay="0.2s"
                          >
                            <div class="job-header">
                              <div class="icon">
                                <img
                                  width="60"
                                  height="60"
                                  src="https://media.istockphoto.com/id/992106344/vector/computer-with-checklist-workspace-with-computer-coffee-cup-plant-and-browser-with-checkboxes.jpg?s=612x612&w=0&k=20&c=s7mt9bPVyjDuerRtm0HiWlFIbjOJw_z4D7ewcgeiflU="
                                  class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  loading="lazy"
                                />
                              </div>
                              <h4 class="title">
                                <a href="#">Digital Marketing
</a>
                              </h4>
                            </div>
                            <div class="job-body">
                              <p>
                              Internet to reach consumers. Digital marketing is a broad field, including attracting customers via email, content marketing, search platforms, social media, and more.


                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-10">
                          <div
                            class="jobpost-item hover-border2 wow fadeInDown"
                            data-wow-duration="1.5s"
                            data-wow-delay="0.2s"
                          >
                            <div class="job-header">
                              <div class="icon">
                                <img
                                  width="60"
                                  height="60"
                                  src="https://media.istockphoto.com/id/1355291100/vector/install-web-wordpress-templates.jpg?s=612x612&w=0&k=20&c=j9VdLy9A4c-i99hZ5LJ5m9Fc3MHPSqUuM2L-jVrWKIo="
                                  class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                  alt=""
                                  decoding="async"
                                  loading="lazy"
                                />
                              </div>
                              <h4 class="title">
                                <a href="#">Web Development
</a>
                              </h4>
                            </div>
                            <div class="job-body">
                              <p>
                              Start Developing Your Own Professional Website with Topnotch Media Works


                                <br />
                                <br />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* quote */}
      {/* <div
        className="quote mt-5 text-light text-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.7)) , 
        url(${topnotch_2})`,
        }}
      >
        <h1>
          <strong>Request A Quote</strong>
        </h1>
        <div className="row">
          <div className="col-md-6 col-sm-6 text-center">
            <p className="text-light m-2">
              Brand Planners. User Experience Planners. Shopper Planners.
              Digital Planners. Social media planners. Content Planners. Channel
              Planners. You-name-it planners.
            </p>
          </div>
          <div className="col-md-6 col-sm-6">
            <div class="elementor-widget-container">
              <div
                class="about1-content wow fadeInLeft "
                data-wow-duration="1.5s"
                data-wow-delay="0.2s"
              >
                <Link
                  to="/contacts"
                  class="eg-btn btn--primary btn--lg"
                >
                  Get a Quote
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div> */}


<>
  <section
    className="elementor-section elementor-top-section elementor-element elementor-element-dcffe94 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
    data-id="dcffe94"
    data-element_type="section"
  >
    <div className="elementor-container elementor-column-gap-no">
      <div
        className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d7dd3ff"
        data-id="d7dd3ff"
        data-element_type="column"
      >
        <div className="elementor-widget-wrap elementor-element-populated">
          <div
            className="elementor-element elementor-element-a9515c5 elementor-widget elementor-widget-spinner_slider"
            data-id="a9515c5"
            data-element_type="widget"
            data-widget_type="spinner_slider.default"
          >
            <div className="elementor-widget-container">
              <div className="banner-section5">
                {/* <ul className="banner-social style-2 gap-4">
                  <li>
                    <a href="#">
                      <i className="bx bxl-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="bx bxl-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="bx bxl-pinterest" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="bx bxl-instagram" />
                    </a>
                  </li>
                </ul> */}
                {/* <img
                  decoding="async"
                  src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner5-tirang1.svg"
                  className="banner5-tirang1 img-fluid"
                  alt="image"
                /> */}
                {/* <img
                  decoding="async"
                  src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner5-tirang2.svg"
                  className="banner5-tirang2 img-fluid"
                  alt="image"
                /> */}
                {/* <img
                  decoding="async"
                  src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner5-tirang3.svg"
                  className="banner5-tirang3 img-fluid"
                  alt="image"
                /> */}
                {/* <img
                  decoding="async"
                  src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner5-tirang3-1.svg"
                  className="banner5-tirang4 img-fluid"
                  alt="image"
                /> */}
                {/* <img
                  decoding="async"
                  src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner5-tirang4.svg"
                  className="banner5-tirang5 img-fluid"
                  alt="image"
                /> */}
                <img
                  decoding="async"
                  src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner5-vector-left.png"
                  className="banner5-vector-left img-fluid"
                  alt="image"
                />
                {/* <img
                  decoding="async"
                  src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner5-vector.png"
                  className="banner5-vector img-fluid"
                  alt="image"
                /> */}
                <div className="container">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-xl-6 col-lg-7">
                      <div
                        className="banner-content style-3 wow fadeInLeft"
                        data-wow-duration="1.5s"
                        data-wow-delay="0.2s"
                      >
                        <span className="text-light">Welcome to Our Company</span>
                        <h1  className="text-light">Creative To Plan Your Business Company</h1>
                        <p className="para text-light">
                        We believe innovation and creativity is what makes your business successful. 
                        </p>
                        <div className="button-group gap-4" >
                          {/* <a
                            href="https://www.spinner-wp.egenslab.com/about-us/"
                            className="eg-btn btn--primary5 capsule btn--lg btnn-frst"
                          >
                            Learn More
                          </a> */}
                          <a
                            href="/contacts"
                            className="eg-btn btn--primary5 capsule btn--outline btn--lg btnn-secnd"
                          >
                            GET IN TOUCH
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-5 position-relative d-lg-block d-none">
                      <div className="offer-image-area style-2">
                        <img
                          decoding="async"
                          src="https://media.istockphoto.com/id/1302573377/photo/visual-contents-concept-social-networking-service-streaming-video-communication-network.webp?b=1&s=170667a&w=0&k=20&c=NSFmaZXtss505Wogt1pMlowGO1OHW9p5oe_EqnyDjoc="
                          className="img-fluid banner5-image"
                          alt="image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
 
</>


<div className="page-wrapper sec-mar">
  <article
    id="post-3323"
    className="post-3323 page type-page status-publish hentry"
  >
    <div className="inner-post">
      <div
        data-elementor-type="wp-page"
        data-elementor-id={3323}
        className="elementor elementor-3323"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-7e30091 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="7e30091"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4c25477"
              data-id="4c25477"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-98673d5 elementor-widget elementor-widget-spinner_heading"
                  data-id="98673d5"
                  data-element_type="widget"
                  data-widget_type="spinner_heading.default"
                >
                  <div className="elementor-widget-container">
                    <div className="section-title  primary4 position-relative">
                      <span>-What We Offer-</span>
                      <h3 className="text-light">Why Choose Us</h3>
                      <p className="para mb-0">
                      We develop strategies which would give you maximum profitability and help. 
                        <br />  your business achieve higher place in the industry.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-a94480f elementor-widget elementor-widget-spinner_services"
                  data-id="a94480f"
                  data-element_type="widget"
                  data-widget_type="spinner_services.default"
                >
                  <div className="elementor-widget-container">
                   
                    <div className="service-section4  position-relative">
                      <div>
                        <div className="row g-4 justify-content-center">
                          {/* <div className="col-md-6 col-sm-6 col-11">
                            <div
                              className="service-item4 hover-border4 wow fadeInDown"
                              data-wow-duration="1.5s"
                              data-wow-delay="0.2s"
                            >
                              <div className="row d-flex justify-content-center g-2 text-sm-start text-center">
                                <div className="col-lg-3 col-md-12 p-0">
                                  <div className="service-img">
                                    <img
                                      decoding="async"
                                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/service44.png"
                                      className="img-fluid"
                                      alt="image"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-9 col-md-12 p-0">
                                  <div className="service-content">
                                    <h4>
                                      <a href="#">
                                      Innovative and creative minds
                                      </a>
                                    </h4>
                                    <p className="para">
                                    We believe innovation and creativity is what makes your business successful. We have teams that have years of education and work experience and are innovative and creative in their fields which will help you give your business a boost it needs. 

                                    </p>
                                    <br />
                                   
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="col-md-6 col-sm-6 col-11">
                            <div
                              className="service-item4 hover-border4 wow fadeInDown"
                              data-wow-duration="1.5s"
                              data-wow-delay="0.2s"
                            >
                              <div className="row d-flex justify-content-center g-2 text-sm-start text-center">
                                <div className="col-lg-3 col-md-12 p-0">
                                  <div className="service-img">
                                    <img
                                      decoding="async"
                                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/service43-1.png"
                                      className="img-fluid"
                                      alt="image"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-9 col-md-12 p-0">
                                  <div className="service-content">
                                    <h4>
                                      <a href="#">
                                        
                                        Full satisfaction
                                      </a>
                                    </h4>
                                    <p className="para">
                                    Your satisfaction is our passion. We develop strategies which would give you maximum profitability and help your business achieve higher place in the industry. We derive solutions and make you believe that “Top Notch” helps you achieve a top notch in the business industry. 

                                    </p>
                                   
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                          <div className="col-md-6 col-sm-6 col-11">
                            <div
                              className="service-item4 hover-border4 wow fadeInDown"
                              data-wow-duration="1.5s"
                              data-wow-delay="0.2s"
                            >
                              <div className="row d-flex justify-content-center g-2 text-sm-start text-center">
                                <div className="col-lg-3 col-md-12 p-0">
                                  <div className="service-img">
                                    <img
                                      decoding="async"
                                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/service42.png"
                                      className="img-fluid"
                                      alt="image"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-9 col-md-12 p-0">
                                  <div className="service-content">
                                    <h4>
                                      <a href="#">Strategical thinking</a>
                                    </h4>
                                    <p className="para">
                                    We make our own strategy and create a strong base for your business which would give you the results you desire. 
                                    </p>
                                    <br />
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-6 col-11">
                            <div
                              className="service-item4 hover-border4 wow fadeInDown"
                              data-wow-duration="1.5s"
                              data-wow-delay="0.2s"
                            >
                              <div className="row d-flex justify-content-center g-2 text-sm-start text-center">
                                <div className="col-lg-3 col-md-12 p-0">
                                  <div className="service-img">
                                    <img
                                      decoding="async"
                                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/service41.png"
                                      className="img-fluid"
                                      alt="image"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-9 col-md-12 p-0">
                                  <div className="service-content">
                                    <h4>
                                      <a href="#">Maximum profitability</a>
                                    </h4>
                                    <p className="para">
                                    To make your name a brand, you need to work on your business to get the maximum profitability you deserve. Start your business with us and get your future ready.


                                    </p>
                                    {/* <a
                                      href="https://www.spinner-wp.egenslab.com/services/seo-optimize/"
                                      className="text-btn"
                                    >
                                      Read More
                                      <svg
                                        width={18}
                                        height={10}
                                        viewBox="0 0 18 10"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M11.1818 1.38021V5V8.61979C11.1818 8.78083 11.3624 8.87583 11.4951 8.7846L17 5L11.4951 1.2154C11.3624 1.12417 11.1818 1.21917 11.1818 1.38021Z" />
                                        <path d="M1 4.5C0.723858 4.5 0.5 4.72386 0.5 5C0.5 5.27614 0.723858 5.5 1 5.5V4.5ZM11.4951 1.2154L11.2119 1.62742L11.2119 1.62742L11.4951 1.2154ZM17 5L17.2833 5.41202L17.8826 5L17.2833 4.58798L17 5ZM11.4951 8.7846L11.2119 8.37258L11.2119 8.37258L11.4951 8.7846ZM1 5.5H11.1818V4.5H1V5.5ZM11.6818 5V1.38021H10.6818V5H11.6818ZM11.2119 1.62742L16.7167 5.41202L17.2833 4.58798L11.7784 0.803376L11.2119 1.62742ZM16.7167 4.58798L11.2119 8.37258L11.7784 9.19662L17.2833 5.41202L16.7167 4.58798ZM11.6818 8.61979V5H10.6818V8.61979H11.6818ZM11.2119 8.37258C11.4109 8.23573 11.6818 8.37824 11.6818 8.61979H10.6818C10.6818 9.18342 11.3139 9.51593 11.7784 9.19662L11.2119 8.37258ZM11.6818 1.38021C11.6818 1.62176 11.4109 1.76427 11.2119 1.62742L11.7784 0.803377C11.3139 0.484066 10.6818 0.81658 10.6818 1.38021H11.6818Z" />
                                      </svg>
                                    </a> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Content Five */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </article>
</div>


<div className="page-wrapper sec-mar">
  <article
    id="post-1478"
    className="post-1478 page type-page status-publish hentry"
  >
    <div className="inner-post">
      <div
        data-elementor-type="wp-page"
        data-elementor-id={1478}
        className="elementor elementor-1478"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-7ad5ce7 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="7ad5ce7"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6801653"
              data-id={6801653}
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-ab1ccb3 elementor-widget elementor-widget-spinner_servicelist"
                  data-id="ab1ccb3"
                  data-element_type="widget"
                  data-widget_type="spinner_servicelist.default"
                >
                  <div className="elementor-widget-container">
                    {/* Content start */}
                    <div className="service-widget service-list-area">
                      <h4 className="sidebar-title">All Services</h4>
                      <ul className="service-list">
                        <li>
                          <Link to="/digitalmarketing">
                            Digital Marketing
                          </Link>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={16}
                            viewBox="0 0 20 16"
                            fill="none"
                          >
                            <path
                              d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                              fill="#18212E"
                            />
                          </svg>
                        </li>
                        <li>
                          <Link to="/branding">
                          Branding
                          </Link>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={16}
                            viewBox="0 0 20 16"
                            fill="none"
                          >
                            <path
                              d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                              fill="#18212E"
                            />
                          </svg>
                        </li>
                        <li>
                          <Link to="/advertisements">
                            Advertisements
                          </Link>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={16}
                            viewBox="0 0 20 16"
                            fill="none"
                          >
                            <path
                              d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                              fill="#18212E"
                            />
                          </svg>
                        </li>
                        <li>
                          <Link to="/webdesigning">
                            Website Development
                          </Link>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={16}
                            viewBox="0 0 20 16"
                            fill="none"
                          >
                            <path
                              d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                              fill="#18212E"
                            />
                          </svg>
                        </li>
                        <li>
                          <Link to="/seo">
                            SEO Optimize
                          </Link>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={16}
                            viewBox="0 0 20 16"
                            fill="none"
                          >
                            <path
                              d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
                              fill="#18212E"
                            />
                          </svg>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-ec55ce1"
              data-id="ec55ce1"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4301355 elementor-widget elementor-widget-image"
                  data-id={4301355}
                  data-element_type="widget"
                  data-widget_type="image.default"
                >
                  <div className="elementor-widget-container">
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          '/*! elementor - v3.7.8 - 02-10-2022 */\n.elementor-widget-image{text-align:center}.elementor-widget-image a{display:inline-block}.elementor-widget-image a img[src$=".svg"]{width:48px}.elementor-widget-image img{vertical-align:middle;display:inline-block}'
                      }}
                    />
                    {/* <img
                      decoding="async"
                      width={880}
                      height={840}
                      src="data:image/jpeg;base64,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"
                      className="attachment-large size-large"
                      alt=""
                      loading="lazy"
                      srcSet="data:image/jpeg;base64,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 880w, https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/servc-details-300x184.png 300w, https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/servc-details-768x471.png 768w, https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/servc-details-370x227.png 370w"
                      sizes="(max-width: 880px) 100vw, 880px"
                    /> */}
                    <img  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGCCXQrnheppZ5ww37zZckCnuyr07vAm1Q77UaLQFMMg&usqp=CAU&ec=48665698" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-38aeec9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="38aeec9"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-81b3510"
              data-id="81b3510"
              data-element_type="column"
              data-settings='{"background_background":"classic"}'
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4244522 elementor-widget elementor-widget-heading"
                  data-id={4244522}
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container ">
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "/*! elementor - v3.7.8 - 02-10-2022 */\n.elementor-heading-title{padding:0;margin:0;line-height:1}.elementor-widget-heading .elementor-heading-title[class*=elementor-size-]>a{color:inherit;font-size:inherit;line-height:inherit}.elementor-widget-heading .elementor-heading-title.elementor-size-small{font-size:15px}.elementor-widget-heading .elementor-heading-title.elementor-size-medium{font-size:19px}.elementor-widget-heading .elementor-heading-title.elementor-size-large{font-size:29px}.elementor-widget-heading .elementor-heading-title.elementor-size-xl{font-size:39px}.elementor-widget-heading .elementor-heading-title.elementor-size-xxl{font-size:59px}"
                      }}
                    />
                    <h4 className="elementor-heading-title elementor-size-default text-center p-2">
                      Offer Banner
                    </h4>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-1c2b4d8 elementor-widget elementor-widget-heading"
                  data-id="1c2b4d8"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h3 className="elementor-heading-title elementor-size-default p-5 text-center">
                      Do You Have a Project <br />
                      In Your Mind
                    </h3>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-2844fc2 elementor-widget elementor-widget-spinner_button"
                  data-id="2844fc2"
                  data-element_type="widget"
                  data-widget_type="spinner_button.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="about1-content wow fadeInLeft text-center"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <Link
                        to="/contacts"
                        className="eg-btn btn--primary btn--lg"
                      >
                        GET STARTED
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6fcb99a"
              data-id="6fcb99a"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-51e1602 elementor-widget elementor-widget-heading"
                  data-id="51e1602"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h3 className="elementor-heading-title elementor-size-default">
                    Innovative and creative minds
                    </h3>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-fc81283 elementor-widget elementor-widget-text-editor"
                  data-id="fc81283"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "/*! elementor - v3.7.8 - 02-10-2022 */\n.elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap{background-color:#818a91;color:#fff}.elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap{color:#818a91;border:3px solid;background-color:transparent}.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap{margin-top:8px}.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter{width:1em;height:1em}.elementor-widget-text-editor .elementor-drop-cap{float:left;text-align:center;line-height:1;font-size:50px}.elementor-widget-text-editor .elementor-drop-cap-letter{display:inline-block}"
                      }}
                    />
                    <p>
                    We believe innovation and creativity is what makes your business successful. We have teams that have years of education and work experience and are innovative and creative in their fields which will help you give your business a boost it needs. 

                    </p>
                  </div>
                </div>
                {/* <div
                  className="elementor-element elementor-element-c7103e4 elementor-widget elementor-widget-text-editor"
                  data-id="c7103e4"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      With this in mind, is there a place for “older” developers
                      in the workforce? Is it too late to change into this field
                      once you’re 30 or above?
                    </p>
                  </div>
                </div> */}
                <div
                  className="elementor-element elementor-element-261a1ec elementor-widget elementor-widget-heading"
                  data-id="261a1ec"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h3 className="elementor-heading-title elementor-size-default">
                    Full satisfaction
                    </h3>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-ca9b29b elementor-widget elementor-widget-text-editor"
                  data-id="ca9b29b"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                    Your satisfaction is our passion. We develop strategies which would give you maximum profitability and help your business achieve higher place in the industry. We derive solutions and make you believe that “Top Notch” helps you achieve a top notch in the business industry. 

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section
          className="elementor-section elementor-top-section elementor-element elementor-element-caf6ea5 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="caf6ea5"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-20e185d"
              data-id="20e185d"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap"></div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-d0535c7"
              data-id="d0535c7"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-13c84a4 elementor-widget elementor-widget-heading"
                  data-id="13c84a4"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h2 className="elementor-heading-title elementor-size-default">
                      Planning Project
                    </h2>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-b740b9f elementor-widget elementor-widget-text-editor"
                  data-id="b740b9f"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <ul className="proj-planlist">
                      <li className="text-light">
                        <svg
                          width={24}
                          height={11}
                          viewBox="0 0 24 11"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16.9995 0.454667V5.50002V10.5454C16.9995 10.7194 17.2064 10.8104 17.3347 10.6928L22.9995 5.50002L17.3347 0.307236C17.2064 0.189646 16.9995 0.280646 16.9995 0.454667Z" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.8217 1.32396V9.67604L22.5347 5.5L17.8217 1.32396ZM16.8316 0.671268C16.8316 0.0883502 17.5485 -0.216486 17.993 0.177416L24 5.5L17.993 10.8226C17.5485 11.2165 16.8316 10.9117 16.8316 10.3287V5.97853H0.49506C0.221646 5.97853 0 5.76429 0 5.5C0 5.23571 0.221646 5.02147 0.49506 5.02147H16.8316V0.671268Z"
                          />
                        </svg>
                        Analyzing research data and identifying.
                      </li>
                      <li  className="text-light">
                        <svg
                          width={24}
                          height={11}
                          viewBox="0 0 24 11"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16.9995 0.454667V5.50002V10.5454C16.9995 10.7194 17.2064 10.8104 17.3347 10.6928L22.9995 5.50002L17.3347 0.307236C17.2064 0.189646 16.9995 0.280646 16.9995 0.454667Z" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.8217 1.32396V9.67604L22.5347 5.5L17.8217 1.32396ZM16.8316 0.671268C16.8316 0.0883502 17.5485 -0.216486 17.993 0.177416L24 5.5L17.993 10.8226C17.5485 11.2165 16.8316 10.9117 16.8316 10.3287V5.97853H0.49506C0.221646 5.97853 0 5.76429 0 5.5C0 5.23571 0.221646 5.02147 0.49506 5.02147H16.8316V0.671268Z"
                          />
                        </svg>
                        Conducting usability testing sessions.
                      </li>
                      <li>
                        <svg
                          width={24}
                          height={11}
                          viewBox="0 0 24 11"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16.9995 0.454667V5.50002V10.5454C16.9995 10.7194 17.2064 10.8104 17.3347 10.6928L22.9995 5.50002L17.3347 0.307236C17.2064 0.189646 16.9995 0.280646 16.9995 0.454667Z" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.8217 1.32396V9.67604L22.5347 5.5L17.8217 1.32396ZM16.8316 0.671268C16.8316 0.0883502 17.5485 -0.216486 17.993 0.177416L24 5.5L17.993 10.8226C17.5485 11.2165 16.8316 10.9117 16.8316 10.3287V5.97853H0.49506C0.221646 5.97853 0 5.76429 0 5.5C0 5.23571 0.221646 5.02147 0.49506 5.02147H16.8316V0.671268Z"
                          />
                        </svg>
                        Amazing Timing and Experience.
                      </li>
                      <li>
                        <svg
                          width={24}
                          height={11}
                          viewBox="0 0 24 11"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16.9995 0.454667V5.50002V10.5454C16.9995 10.7194 17.2064 10.8104 17.3347 10.6928L22.9995 5.50002L17.3347 0.307236C17.2064 0.189646 16.9995 0.280646 16.9995 0.454667Z" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.8217 1.32396V9.67604L22.5347 5.5L17.8217 1.32396ZM16.8316 0.671268C16.8316 0.0883502 17.5485 -0.216486 17.993 0.177416L24 5.5L17.993 10.8226C17.5485 11.2165 16.8316 10.9117 16.8316 10.3287V5.97853H0.49506C0.221646 5.97853 0 5.76429 0 5.5C0 5.23571 0.221646 5.02147 0.49506 5.02147H16.8316V0.671268Z"
                          />
                        </svg>
                        Gathering user feedback through surveys.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-06af56e"
              data-id="06af56e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-7493edc elementor-widget elementor-widget-image"
                  data-id="7493edc"
                  data-element_type="widget"
                  data-widget_type="image.default"
                >
                  <div className="elementor-widget-container">
                    <img
                      decoding="async"
                      width={370}
                      height={200}
                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/service-details2.png"
                      className="attachment-large size-large"
                      alt=""
                      loading="lazy"
                      srcSet="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/service-details2.png 370w, https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/service-details2-300x162.png 300w"
                      sizes="(max-width: 370px) 100vw, 370px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-cd54ed6 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="cd54ed6"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7a62df1"
              data-id="7a62df1"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap"></div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7140758"
              data-id={7140758}
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                {/* <div
                  className="elementor-element elementor-element-4a3994b elementor-widget elementor-widget-heading"
                  data-id="4a3994b"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h2 className="elementor-heading-title elementor-size-default">
                      Work Process
                    </h2>
                  </div>
                </div> */}
                {/* <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-3c308b5 elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="3c308b5"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-c72d8ca"
                      data-id="c72d8ca"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-a39c82b elementor-widget elementor-widget-image"
                          data-id="a39c82b"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <img
                              decoding="async"
                              width={300}
                              height={300}
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/work-procs1.svg"
                              className="attachment-medium size-medium"
                              alt=""
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-81bac7a elementor-widget elementor-widget-heading"
                          data-id="81bac7a"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Research
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-586a450"
                      data-id="586a450"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-2dbec7c elementor-widget elementor-widget-image"
                          data-id="2dbec7c"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <img
                              decoding="async"
                              width={300}
                              height={300}
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/work-procs2-1.svg"
                              className="attachment-medium size-medium"
                              alt=""
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-8ffef43 elementor-widget elementor-widget-heading"
                          data-id="8ffef43"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Idea
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-e7a252a"
                      data-id="e7a252a"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-69a0c0a elementor-widget elementor-widget-image"
                          data-id="69a0c0a"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <img
                              decoding="async"
                              width={300}
                              height={300}
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/work-procs3.svg"
                              className="attachment-medium size-medium"
                              alt=""
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-373f79b elementor-widget elementor-widget-heading"
                          data-id="373f79b"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Develop
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-97dac4d"
                      data-id="97dac4d"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-efc2910 elementor-widget elementor-widget-image"
                          data-id="efc2910"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <img
                              decoding="async"
                              width={300}
                              height={300}
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/work-procs4.svg"
                              className="attachment-medium size-medium"
                              alt=""
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-0ca8d15 elementor-widget elementor-widget-heading"
                          data-id="0ca8d15"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Launch
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section> */}
              </div>
            </div>
          </div>
        </section>
        {/* <section
          className="elementor-section elementor-top-section elementor-element elementor-element-526d2f8 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="526d2f8"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b234b18"
              data-id="b234b18"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap"></div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0f11a1d"
              data-id="0f11a1d"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-a53fa23 elementor-widget elementor-widget-heading"
                  data-id="a53fa23"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h2 className="elementor-heading-title elementor-size-default">
                      FAQ This Services
                    </h2>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-45f2543 elementor-widget elementor-widget-spinner_faq"
                  data-id="45f2543"
                  data-element_type="widget"
                  data-widget_type="spinner_faq.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="faq-wrap wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay=".2s"
                    >
                      <div className="faq-item hover-btn">
                        <span />
                        <h5
                          id="heading0"
                          className="accordion-button style-2 collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse0"
                          aria-controls="collapse0"
                        >
                          01. Curious about how to build your own UX strategy?
                          Here are five simple steps.
                        </h5>
                        <div
                          id="collapse0"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading0"
                        >
                          <div className="faq-body style-2">
                            Morbi aliquam quis quam in luctus. Nullam tincidunt
                            pulvinar imperdiet. Sed varius, diam vitae posuere
                            semper, libero ex hendrerit nunc, ac sagittis eros
                            metus ut diam. Donec a nibh in libero maximus
                            vehicula. Etiam sit amet condimentum erat.
                            Pellentesque ultrices sagittis turpis, quis tempus
                            ante viverra et.Morbi aliquam quis quam in luctus.
                            Nullam tincidunt pulvinar imperdiet. Sed varius,
                            diam vitae posuere semper, tincidunt pulvinar
                            imperdiet. Sed varius, diam vitae posuere semper.
                          </div>
                        </div>
                      </div>
                      <div className="faq-item hover-btn">
                        <span />
                        <h5
                          id="heading1"
                          className="accordion-button style-2 collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse1"
                          aria-controls="collapse1"
                        >
                          02. Where Could a Career in UX Take You? Agency vs.
                          In-House vs. Freelance?
                        </h5>
                        <div
                          id="collapse1"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading1"
                        >
                          <div className="faq-body style-2">
                            Morbi aliquam quis quam in luctus. Nullam tincidunt
                            pulvinar imperdiet. Sed varius, diam vitae posuere
                            semper, libero ex hendrerit nunc, ac sagittis eros
                            metus ut diam. Donec a nibh in libero maximus
                            vehicula. Etiam sit amet condimentum erat.
                            Pellentesque ultrices sagittis turpis, quis tempus
                            ante viverra et.Morbi aliquam quis quam in luctus.
                            Nullam tincidunt pulvinar imperdiet. Sed varius,
                            diam vitae posuere semper, tincidunt pulvinar
                            imperdiet. Sed varius, diam vitae posuere semper.
                          </div>
                        </div>
                      </div>
                      <div className="faq-item hover-btn">
                        <span />
                        <h5
                          id="heading2"
                          className="accordion-button style-2 collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse2"
                          aria-controls="collapse2"
                        >
                          03. What Is a Problem Statement in UX? (And How To
                          Write One?
                        </h5>
                        <div
                          id="collapse2"
                          className="accordion-collapse collapse"
                          aria-labelledby="heading2"
                        >
                          <div className="faq-body style-2">
                            Morbi aliquam quis quam in luctus. Nullam tincidunt
                            pulvinar imperdiet. Sed varius, diam vitae posuere
                            semper, libero ex hendrerit nunc, ac sagittis eros
                            metus ut diam. Donec a nibh in libero maximus
                            vehicula. Etiam sit amet condimentum erat.
                            Pellentesque ultrices sagittis turpis, quis tempus
                            ante viverra et.Morbi aliquam quis quam in luctus.
                            Nullam tincidunt pulvinar imperdiet. Sed varius,
                            diam vitae posuere semper, tincidunt pulvinar
                            imperdiet. Sed varius, diam vitae posuere semper.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-f1f4e68 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="f1f4e68"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-29e62f3"
              data-id="29e62f3"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-620c036 elementor-widget elementor-widget-spinner_join"
                  data-id="620c036"
                  data-element_type="widget"
                  data-widget_type="spinner_join.default"
                >
                  <div className="elementor-widget-container">
                    <div className="join-section">
                      <div
                        className="joinus-area d-flex align-items-center wow fadeInUp"
                        data-wow-duration="1.5s"
                        data-wow-delay="0.2s"
                      >
                        <div className="row d-flex align-items-center g-2">
                          <div className="col-lg-7 justify-content-lg-start justify-content-center text-lg-start text-center">
                            <p>
                            Brand Planners. User Experience Planners. Shopper Planners. Digital Planners. Social media planners. Content Planners. Channel Planners. You-name-it planners.
                            </p>
                          </div>
                          <div className="col-lg-5 d-flex justify-content-lg-end justify-content-center">
                            <Link
                              to="/contacts"
                              className="eg-btn btn--primary3 capsule joinus-btn"
                            >
                              Join Us
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-3c63583 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="3c63583"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e9b2ca4"
              data-id="e9b2ca4"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-cbcac13 elementor-widget elementor-widget-spinner_clients"
                  data-id="cbcac13"
                  data-element_type="widget"
                  data-widget_type="spinner_clients.default"
                >
               
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </article>
</div>

      
    </>
  );
}
